import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild,ViewEncapsulation } from '@angular/core';
import { PrivacyStatementPopup } from "../models/privacy-popup.service";

import {
  IKeyValueInterface,
  IAPIResponse,
  ApplicationRouteURL,
  WeGoConfig
} from "../../shared/config";

import { AuthService } from "./../../shared/models/auth.service";

@Component({
  selector: 'wego-privacy-popup',
  template: require('../views/privacy-popup.component.html'),
  providers: [PrivacyStatementPopup],
  encapsulation: ViewEncapsulation.None,
  styles: [ `
  span.popimgstyle img {
    max-width: 100% !important;
    height: auto !important;
}
`]
})

export class PrivacyPopupComponent implements OnInit {
  @ViewChild('privayStatementModel') public privayStatementModel: ModalDirective;

  bodyHTMLText: string;

  constructor(
    private authService: AuthService
  ) { }

  ngOnInit() {

  }

  private Confirm($event: any) {
    this.hide();
  }

  public show(bodyHTMLText: string) {
    this.bodyHTMLText = bodyHTMLText;
    this.privayStatementModel.show();
  }

  public hide() {
    this.privayStatementModel.hide();
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/privacypopup/component/privacy-popup.component.ts